<!-- this.router.url !== currentUrl -->
<ng-container>
   <app-header *ngIf="!this.hasRoute('/report')"></app-header>
   <section
      [ngClass]="{
         'container-section': !this.hasRoute('/report'),
         container: !this.hasRoute('/report')
      }"
   >
      <div *ngIf="!this.hasRoute('/report')" class="mobile-nav">
         <div
            class="toggler"
            (click)="toggler()"
            [ngClass]="{ onclick: this.expandedToggler === 1 }"
            #toggleButton
         >
            <span class="first"></span>
            <span class="second"></span>
            <span class="third"></span>
         </div>
<div class="flex buttonsMobile">
   <a routerLink="upload-files" class="plus active upload-mobile" title="Upload">
      <i class="fas fa-plus"></i>
      <span>Upload</span>
   </a>
       <a routerLink="detector" class="plus active upload-mobile" title="Upload">
      <span>AI Detector</span>
   </a>
</div>
      </div>
      <nav
         *ngIf="this.userRole == '2' && !this.hasRoute('/report')"
         class="nav-bar"
         [ngClass]="{ expand: this.expandedToggler === 1 }"
         #navbar
      >
      <a routerLink="detector" routerLinkActive="active" title="AI Detector" class="" title="Upload"
      ><svg version="1.1" id="textDetector" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
  <style type="text/css">
     .st0{fill:#434343;}
  </style>
  <path class="st0" d="M481.7,240.2H289.1v-96.5h57.5v9.5v19.6h19.6h19h19.6v-19.6v-48.4V85.5v-0.3H95.5v0.3v19.3v48.4v19.6h19.6h19
     h19.6v-19.6v-9.5h57.5v96.5H17.9v19.6h463.8V240.2z M230.9,143.7v-19.6h-19.6h-57.5h-19.6v19.6v9.5h-19v-48.4h270.1v48.4h-19v-9.5
     v-19.6h-19.6h-57.5h-19.6v19.6v96.5h-38.6V143.7z"/>
  <rect x="211.2" y="279.1" class="st0" width="77.9" height="19.6"/>
  <rect x="211.2" y="318.4" class="st0" width="77.9" height="19.6"/>
  <rect x="182.8" y="357.6" class="st0" width="134.7" height="19.6"/>
  <rect x="182.8" y="394.9" class="st0" width="134.7" height="19.6"/>
  </svg><span>Detector</span>
   </a>
         <a routerLink="upload" class="plus active" title="Upload"
            ><svg id="dashboard"
               is="plus"
               xmlns="http://www.w3.org/2000/svg"
               width="33"
               height="66"
               viewBox="0 0 33 66"
            >
               <text
                  id="_"
                  data-name="+"
                  transform="translate(0 52)"
                  fill="#fff"
                  font-size="54"
                  font-family="Montserrat-Bold, Montserrat"
                  font-weight="700"
               >
                  <tspan x="0" y="0">+</tspan>
               </text></svg
            ><span>Upload</span>
         </a>
         <a routerLink="dashboard" routerLinkActive="active" title="Dashboard"
            ><svg
               id="dashboard"
               xmlns="http://www.w3.org/2000/svg"
               width="38"
               height="38"
               viewBox="0 0 38 38"
            >
               <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M14.643,12.669H2.768A2.775,2.775,0,0,1,0,9.893V2.768A2.768,2.768,0,0,1,2.768,0H14.643a2.768,2.768,0,0,1,2.768,2.768V9.893A2.77,2.77,0,0,1,14.643,12.669ZM2.768,2.375a.4.4,0,0,0-.393.393V9.893a.4.4,0,0,0,.393.393H14.643a.4.4,0,0,0,.393-.393V2.768a.4.4,0,0,0-.393-.393H2.768Z"
                  fill="#434343"
               />
               <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M14.643,235.562H2.768A2.768,2.768,0,0,1,0,232.793V216.168A2.768,2.768,0,0,1,2.768,213.4H14.643a2.768,2.768,0,0,1,2.768,2.768v16.625A2.764,2.764,0,0,1,14.643,235.562ZM2.768,215.768a.4.4,0,0,0-.393.393v16.625a.4.4,0,0,0,.393.393H14.643a.4.4,0,0,0,.393-.393V216.161a.4.4,0,0,0-.393-.393Z"
                  transform="translate(0 -197.562)"
                  fill="#434343"
               />
               <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M292.043,354.062H280.168a2.768,2.768,0,0,1-2.768-2.768v-7.125a2.768,2.768,0,0,1,2.768-2.768h11.875a2.768,2.768,0,0,1,2.768,2.768v7.125A2.768,2.768,0,0,1,292.043,354.062Zm-11.875-10.294a.4.4,0,0,0-.393.393v7.125a.4.4,0,0,0,.393.393h11.875a.4.4,0,0,0,.393-.393v-7.125a.4.4,0,0,0-.393-.393Z"
                  transform="translate(-256.812 -316.062)"
                  fill="#434343"
               />
               <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M292.043,22.261H280.168a2.768,2.768,0,0,1-2.768-2.768V2.868A2.768,2.768,0,0,1,280.168.1h11.875a2.757,2.757,0,0,1,2.768,2.761V19.486A2.775,2.775,0,0,1,292.043,22.261ZM280.168,2.467a.4.4,0,0,0-.393.393V19.486a.4.4,0,0,0,.393.393h11.875a.4.4,0,0,0,.393-.393V2.861a.4.4,0,0,0-.393-.393H280.168Z"
                  transform="translate(-256.812 -0.092)"
                  fill="#434343"
               /></svg
            ><span>Dashboard</span>
         </a>
         <a routerLink="add-credits" routerLinkActive="active" title="Add Credit">
            <svg
               id="add-credit-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="48.704"
               height="43.408"
               viewBox="0 0 48.704 43.408"
            >
               <g
                  id="Group_18"
                  data-name="Group 18"
                  transform="translate(-1585.591 -283.432)"
               >
                  <path
                     id="coins"
                     d="M115.384,9.805c-.069-1.181-1.459-2.084-4.307-2.848a2.029,2.029,0,0,0,.139-.625V1.468h0C110.938-2.561,94.4-2.7,92.458-2.7c-1.876,0-18.48.139-18.758,4.168h0v.069h0V6.331c0,1.32,1.737,2.362,4.238,3.126,0,.139-.069.208-.069.347h0v.069h0v4.794c-2.709.695-4.1,1.6-4.168,2.779h0v.069h0V22.31c0,.9.834,1.667,2.154,2.362a.881.881,0,0,0-.069.417h0v.069h0v4.794c0,2.293,5.21,3.752,10.977,4.446h.208c1.112.139,2.223.208,3.335.278h.139c1.389.069,2.848.139,4.1.139s2.709-.069,4.1-.139h.139c1.112-.069,2.223-.139,3.335-.278h.208c5.766-.695,10.977-2.084,10.977-4.446V25.089h0c-.069-.834-.764-1.528-2.223-2.154a2.029,2.029,0,0,0,.139-.625V17.795c2.5-.764,4.168-1.806,4.168-3.126V9.805Zm-1.389.069c-.069.486-1.112,1.112-3.057,1.667h0a46,46,0,0,1-11.185,1.667H93.5a46,46,0,0,1-11.185-1.667h0c-1.876-.556-2.987-1.181-3.057-1.667V9.805H79.4l.834.208a41.161,41.161,0,0,0,4.516.695h0c1.112.139,2.293.208,3.474.278h0c.834.069,1.737.069,2.57.139H93.5a54.186,54.186,0,0,0,12.991-1.6c.139-.069.278-.069.417-.139.069,0,.208-.069.278-.069a2.08,2.08,0,0,0,.695-.278c.069,0,.069,0,.139-.069a4.787,4.787,0,0,0,.556-.208.243.243,0,0,0,.139-.069c.208-.069.347-.208.556-.278.069-.069.139-.069.208-.139s.139-.069.278-.139c.069,0,.069-.069.139-.069C113.091,8.833,113.925,9.6,113.994,9.875ZM92.527-1.311C103.99-1.311,109.756.5,109.9,1.538c-.069.486-1.181,1.112-3.057,1.667h0A46,46,0,0,1,95.653,4.873H89.4A46,46,0,0,1,78.216,3.205h0c-1.876-.556-2.987-1.181-3.057-1.667C75.228.5,81.064-1.311,92.527-1.311Zm-14.034,17.3h0c.973.973,2.987,1.737,5.419,2.293.069,0,.139,0,.139.069.208.069.347.069.556.139a48.389,48.389,0,0,0,7.85.973h0c.973.069,1.876.069,2.918.139h2.709c.9,0,1.806-.069,2.709-.139h0a50.81,50.81,0,0,0,7.989-1.042,10.7,10.7,0,0,1-2.084.834h0a45.3,45.3,0,0,1-12.019,1.667H89.262a46,46,0,0,1-11.185-1.667h0C76.132,18.7,75.089,18,75.02,17.586,75.228,17.239,75.923,16.613,78.494,15.988Zm33.416,9.17c-.069.486-1.112,1.112-3.057,1.667h0a46,46,0,0,1-11.185,1.667H91.416A46,46,0,0,1,80.23,26.826h0c-1.806-.556-2.918-1.181-3.057-1.667l.625.208h.069a1.635,1.635,0,0,0,.556.139c.069,0,.139.069.208.069.139,0,.208.069.347.069a52.606,52.606,0,0,0,9.24,1.32h0c1.112.069,2.154.069,3.265.139h2.084c1.042,0,2.015-.069,2.987-.139h0c1.181-.069,2.362-.208,3.474-.278h.069c1.251-.139,2.432-.347,3.474-.556.208-.069.417-.069.695-.139h.139a18.04,18.04,0,0,0,5.072-1.667c.069-.069.139-.069.208-.139s.139-.069.208-.139.139-.069.208-.139C111.493,24.533,111.91,25.02,111.91,25.159Z"
                     transform="translate(1511.891 286.132)"
                     fill="#434343"
                  />
                  <g
                     id="Ellipse_3"
                     data-name="Ellipse 3"
                     transform="translate(1612.295 305.84)"
                     fill="#434343"
                     stroke="#fff"
                     stroke-width="3"
                  >
                     <ellipse
                        cx="11"
                        cy="10.5"
                        rx="11"
                        ry="10.5"
                        stroke="none"
                     />
                     <ellipse cx="11" cy="10.5" rx="9.5" ry="9" fill="none" />
                  </g>
                  <text
                     id="_"
                     data-name="+"
                     transform="translate(1619.295 320.84)"
                     fill="#fff"
                     font-size="14"
                     font-family="Montserrat-Black, Montserrat"
                     font-weight="800"
                  >
                     <tspan x="0" y="0">+</tspan>
                  </text>
               </g></svg
            ><span>Add Credit</span>
         </a>
         <a routerLink="statistics" routerLinkActive="active" title="Dashboard"
            ><svg
               id="statistics-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="40.214"
               height="36.2"
               viewBox="0 0 40.214 36.2"
            >
               <g id="graph" transform="translate(0 -25.55)">
                  <g
                     id="Group_2"
                     data-name="Group 2"
                     transform="translate(0 25.55)"
                  >
                     <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M36.2,25.55a4.011,4.011,0,0,0-2.891,6.8l-7.345,14.7A3.3,3.3,0,0,0,25.476,47a4.012,4.012,0,0,0-1.516.3l-5.7-6.418a4.013,4.013,0,1,0-7.526-1.933,3.991,3.991,0,0,0,.99,2.608L4.737,53.776a3.676,3.676,0,0,0-.715-.071,4.078,4.078,0,1,0,3.032,1.414L14.031,42.9a3.782,3.782,0,0,0,2.223-.228l5.7,6.418a4.018,4.018,0,1,0,6.4-.848l7.345-14.7a3.3,3.3,0,0,0,.487.047A4.022,4.022,0,0,0,36.2,25.55Z"
                        transform="translate(0 -25.55)"
                        fill="#434343"
                     />
                  </g>
               </g></svg
            ><span>Dashboard</span>
         </a>
         <a routerLink="profile" routerLinkActive="active" title="Account"
            ><svg
               id="profile-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="38.334"
               height="42.826"
               viewBox="0 0 38.334 42.826"
            >
               <g id="user" transform="translate(-24.165)">
                  <g
                     id="Group_20"
                     data-name="Group 20"
                     transform="translate(32.216)"
                  >
                     <g id="Group_19" data-name="Group 19">
                        <path
                           id="Path_14"
                           data-name="Path 14"
                           d="M121.91,0a11.119,11.119,0,1,0,11.119,11.119A11.149,11.149,0,0,0,121.91,0Z"
                           transform="translate(-110.791)"
                           fill="#434343"
                        />
                     </g>
                  </g>
                  <g
                     id="Group_22"
                     data-name="Group 22"
                     transform="translate(24.165 23.034)"
                  >
                     <g
                        id="Group_21"
                        data-name="Group 21"
                        transform="translate(0)"
                     >
                        <path
                           id="Path_15"
                           data-name="Path 15"
                           d="M62.417,255.931a10.366,10.366,0,0,0-1.117-2.039,13.821,13.821,0,0,0-9.565-6.021,2.047,2.047,0,0,0-1.408.34,11.852,11.852,0,0,1-13.984,0,1.822,1.822,0,0,0-1.408-.34,13.721,13.721,0,0,0-9.565,6.021,11.952,11.952,0,0,0-1.117,2.039,1.033,1.033,0,0,0,.049.923,19.372,19.372,0,0,0,1.311,1.942,18.457,18.457,0,0,0,2.234,2.525,29.108,29.108,0,0,0,2.234,1.942,22.142,22.142,0,0,0,26.414,0,21.351,21.351,0,0,0,2.234-1.942,22.424,22.424,0,0,0,2.234-2.525,17.026,17.026,0,0,0,1.311-1.942A.829.829,0,0,0,62.417,255.931Z"
                           transform="translate(-24.165 -247.841)"
                           fill="#434343"
                        />
                     </g>
                  </g>
               </g></svg
            ><span>Account</span>
         </a>
         <a routerLink="help-center" routerLinkActive="active" title="Help Center"
            ><svg
               id="help-center-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="41.771"
               height="34.602"
               viewBox="0 0 41.771 34.602"
            >
               <g id="helPCenter" transform="translate(-169 -202.512)">
                  <path
                     id="Path_27"
                     data-name="Path 27"
                     d="M257.382,255.7a13.127,13.127,0,1,1-3.726,25.713.99.99,0,0,0-1.011.188,13.11,13.11,0,0,1-6.816,2.462c-.84.082-1.7.073-2.544.082-.359,0-.807-.082-.791-.522a1.043,1.043,0,0,1,.571-.685,8.341,8.341,0,0,0,3.669-4.19,2.168,2.168,0,0,0-.228-2.6,11.568,11.568,0,0,1-2.112-5.756,12.243,12.243,0,0,1,.294-4.68A13.04,13.04,0,0,1,257.382,255.7Zm-5.96,13.167a1.22,1.22,0,0,0,1.207,1.141,1.2,1.2,0,0,0,1.15-1.125,1.122,1.122,0,0,0-1.052-1.19A1.234,1.234,0,0,0,251.422,268.866Zm7.125-.049a1.089,1.089,0,0,0-1.166-1.125,1.135,1.135,0,0,0-1.15,1.158,1.214,1.214,0,0,0,1.117,1.158A1.178,1.178,0,0,0,258.548,268.817Zm3.538,1.174a1.182,1.182,0,0,0,1.223-1.1,1.152,1.152,0,0,0-1.06-1.2,1.272,1.272,0,0,0-1.3.97A1.255,1.255,0,0,0,262.086,269.991Z"
                     transform="translate(-67.503 -48.851)"
                     fill="#434343"
                  />
                  <path
                     id="Path_28"
                     data-name="Path 28"
                     d="M175.326,225.388a28.976,28.976,0,0,1-4.044-.041,2.836,2.836,0,0,1-2.258-2.837q-.049-3.608,0-7.231a3.061,3.061,0,0,1,2.813-2.935,11.213,11.213,0,0,1,1.655-.016.921.921,0,0,0,1-.587,17.079,17.079,0,0,1,11.381-8.748,17.355,17.355,0,0,1,19.371,8.723.951.951,0,0,0,1.052.611,11.265,11.265,0,0,1,1.484,0,3.085,3.085,0,0,1,2.968,3.033c.024,2.372.033,4.737,0,7.109a3.092,3.092,0,0,1-3.041,3.025c-.652.016-1.3-.024-1.957.024a.77.77,0,0,0-.546.367,16.414,16.414,0,0,1-11.65,10.036.86.86,0,0,0-.489.408,1.3,1.3,0,0,1-1.223.783c-1.011,0-2.014.008-3.025,0a1.244,1.244,0,1,1-.033-2.487c1.027-.016,2.054-.008,3.082,0a.891.891,0,0,1,.563.13c.448.481.938.277,1.419.13,6.3-1.924,10.232-6.066,11.316-12.6a15.484,15.484,0,1,0-30.018,2.487C175.212,224.988,175.261,225.176,175.326,225.388Z"
                     fill="#434343"
                  />
               </g></svg
            ><span>Help Center</span></a
         >
      </nav>
      <nav
         *ngIf="this.userRole == '4' && !this.hasRoute('/report')"
         class="nav-bar"
         [ngClass]="{ expand: this.expandedToggler === 1 }"
         #navbar
      >
      <a routerLink="detector" routerLinkActive="active" title="AI Detector" class="" title="Upload"
      ><svg version="1.1" id="textDetector" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
  <style type="text/css">
     .st0{fill:#434343;}
  </style>
  <path class="st0" d="M481.7,240.2H289.1v-96.5h57.5v9.5v19.6h19.6h19h19.6v-19.6v-48.4V85.5v-0.3H95.5v0.3v19.3v48.4v19.6h19.6h19
     h19.6v-19.6v-9.5h57.5v96.5H17.9v19.6h463.8V240.2z M230.9,143.7v-19.6h-19.6h-57.5h-19.6v19.6v9.5h-19v-48.4h270.1v48.4h-19v-9.5
     v-19.6h-19.6h-57.5h-19.6v19.6v96.5h-38.6V143.7z"/>
  <rect x="211.2" y="279.1" class="st0" width="77.9" height="19.6"/>
  <rect x="211.2" y="318.4" class="st0" width="77.9" height="19.6"/>
  <rect x="182.8" y="357.6" class="st0" width="134.7" height="19.6"/>
  <rect x="182.8" y="394.9" class="st0" width="134.7" height="19.6"/>
  </svg><span>Detector</span>
   </a>
         <a routerLink="register" class="plus active" title="Upload"
            ><svg
               is="plus"
               xmlns="http://www.w3.org/2000/svg"
               width="33"
               height="66"
               viewBox="0 0 33 66"
            >
               <text
                  id="_"
                  data-name="+"
                  transform="translate(0 52)"
                  fill="#fff"
                  font-size="54"
                  font-family="Montserrat-Bold, Montserrat"
                  font-weight="700"
               >
                  <tspan x="0" y="0">+</tspan>
               </text></svg
            ><span>Upload</span>
         </a>
         <a routerLink="statistics" routerLinkActive="active" title="Dashboard">
            <svg
               id="statistics-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="40.214"
               height="36.2"
               viewBox="0 0 40.214 36.2"
            >
               <g id="graph" transform="translate(0 -25.55)">
                  <g
                     id="Group_2"
                     data-name="Group 2"
                     transform="translate(0 25.55)"
                  >
                     <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M36.2,25.55a4.011,4.011,0,0,0-2.891,6.8l-7.345,14.7A3.3,3.3,0,0,0,25.476,47a4.012,4.012,0,0,0-1.516.3l-5.7-6.418a4.013,4.013,0,1,0-7.526-1.933,3.991,3.991,0,0,0,.99,2.608L4.737,53.776a3.676,3.676,0,0,0-.715-.071,4.078,4.078,0,1,0,3.032,1.414L14.031,42.9a3.782,3.782,0,0,0,2.223-.228l5.7,6.418a4.018,4.018,0,1,0,6.4-.848l7.345-14.7a3.3,3.3,0,0,0,.487.047A4.022,4.022,0,0,0,36.2,25.55Z"
                        transform="translate(0 -25.55)"
                        fill="#434343"
                     />
                  </g>
               </g></svg
            ><span>Dashboard</span>
         </a>
         <a routerLink="submissions" routerLinkActive="active" title="Your submissions">
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="44.053"
               height="50.012"
               viewBox="0 0 44.053 50.012"
            >
               <g id="submit" transform="translate(-30.501)">
                  <path
                     id="Path_247"
                     data-name="Path 247"
                     d="M69.747,28.02H63.3V4.579h.929a.823.823,0,0,1,.822.822V25.335a.733.733,0,1,0,1.465,0V5.4a2.29,2.29,0,0,0-2.288-2.288H63.3V2.288A2.29,2.29,0,0,0,61.012,0H42.875a.733.733,0,1,0,0,1.465H61.012a.823.823,0,0,1,.822.822V28.02H57.369a4.812,4.812,0,0,0-4.807,4.807v6.912H32.789a.823.823,0,0,1-.822-.822V9.667h5.928A2.29,2.29,0,0,0,40.182,7.38V.733a.733.733,0,0,0-1.25-.518l-8.215,8.2a.7.7,0,0,0-.215.519V38.916A2.29,2.29,0,0,0,32.789,41.2h.93v.826a2.29,2.29,0,0,0,2.287,2.288H52.562v.887a4.812,4.812,0,0,0,4.807,4.806H69.747a4.812,4.812,0,0,0,4.806-4.806V32.827a4.812,4.812,0,0,0-4.806-4.807ZM38.717,2.5V7.38a.823.823,0,0,1-.822.822H33ZM36.005,42.853a.823.823,0,0,1-.821-.822V41.2H52.562v1.649Zm37.084,2.352a3.345,3.345,0,0,1-3.341,3.341H57.369a3.345,3.345,0,0,1-3.341-3.341V32.827a3.345,3.345,0,0,1,3.341-3.341H69.747a3.345,3.345,0,0,1,3.341,3.341Z"
                     transform="translate(0 0)"
                     fill="#434343"
                  />
                  <path
                     id="Path_248"
                     data-name="Path 248"
                     d="M313.353,323.612a2.632,2.632,0,0,0-4.051,0l-3.67,4.574a2.492,2.492,0,0,0,1.925,4.012h.683v3.818a1.665,1.665,0,0,0,1.663,1.663h2.849a1.665,1.665,0,0,0,1.663-1.663V332.2h.683a2.494,2.494,0,0,0,1.925-4.011Zm2.641,6.552a1.024,1.024,0,0,1-.886.568h-1.426a.733.733,0,0,0-.733.733v4.551a.2.2,0,0,1-.2.2H309.9a.2.2,0,0,1-.2-.2v-4.551a.733.733,0,0,0-.733-.733h-1.426a1,1,0,0,1-.778-1.622l3.676-4.581a1.162,1.162,0,0,1,1.765,0l3.676,4.581A1.031,1.031,0,0,1,315.994,330.164Z"
                     transform="translate(-247.769 -291.144)"
                     fill="#434343"
                  />
                  <path
                     id="Path_249"
                     data-name="Path 249"
                     d="M160.9,48.931a2.335,2.335,0,0,0,0-4.67h-6.879a2.335,2.335,0,0,0,0,4.67Zm-7.748-2.337a.869.869,0,0,1,.868-.868H160.9a.87.87,0,0,1,0,1.74h-6.879A.87.87,0,0,1,153.149,46.594Z"
                     transform="translate(-109.346 -39.938)"
                     fill="#434343"
                  />
                  <path
                     id="Path_250"
                     data-name="Path 250"
                     d="M87.137,141.309a.733.733,0,0,0,.733.733h20.3a.733.733,0,0,0,0-1.465H87.87A.733.733,0,0,0,87.137,141.309Z"
                     transform="translate(-51.104 -126.845)"
                     fill="#434343"
                  />
                  <path
                     id="Path_251"
                     data-name="Path 251"
                     d="M108.171,185.049H87.87a.733.733,0,0,0,0,1.465h20.3a.733.733,0,1,0,0-1.465Z"
                     transform="translate(-51.104 -166.974)"
                     fill="#434343"
                  />
                  <path
                     id="Path_252"
                     data-name="Path 252"
                     d="M260.684,229.521h-3.791a.733.733,0,0,0,0,1.465h3.791a.733.733,0,0,0,0-1.465Z"
                     transform="translate(-203.617 -207.102)"
                     fill="#434343"
                  />
                  <path
                     id="Path_253"
                     data-name="Path 253"
                     d="M101.673,230.254a.733.733,0,0,0-.733-.733H87.87a.733.733,0,1,0,0,1.465h13.071A.733.733,0,0,0,101.673,230.254Z"
                     transform="translate(-51.104 -207.102)"
                     fill="#434343"
                  />
                  <path
                     id="Path_254"
                     data-name="Path 254"
                     d="M96.722,273.994H87.87a.733.733,0,1,0,0,1.465h8.852a.733.733,0,1,0,0-1.465Z"
                     transform="translate(-51.104 -247.231)"
                     fill="#434343"
                  />
                  <path
                     id="Path_255"
                     data-name="Path 255"
                     d="M96.722,318.466H87.87a.733.733,0,1,0,0,1.465h8.852a.733.733,0,1,0,0-1.465Z"
                     transform="translate(-51.104 -287.359)"
                     fill="#434343"
                  />
               </g>
            </svg>
            <span>Your submissions</span>
         </a>
         <a routerLink="administration" routerLinkActive="active" title="Administration">
            <svg
               xmlns="http://www.w3.org/2000/svg"
               id="edit"
               width="51.119"
               height="51.122"
               viewBox="0 0 51.119 51.122"
            >
               <path
                  id="Path_225"
                  data-name="Path 225"
                  d="M12.46,38.244a1.075,1.075,0,0,1-.754-.311,1.064,1.064,0,0,1-.292-.961l1.506-7.53a1.044,1.044,0,0,1,.292-.545L29.78,12.329a3.2,3.2,0,0,1,4.518,0l3.012,3.012a3.2,3.2,0,0,1,0,4.518L20.742,36.427a1.059,1.059,0,0,1-.545.292l-7.53,1.506A1.13,1.13,0,0,1,12.46,38.244Zm2.488-8.071-1.129,5.647,5.647-1.129,16.34-16.34a1.066,1.066,0,0,0,0-1.506l-3.012-3.012a1.066,1.066,0,0,0-1.506,0Zm5.042,5.5h.021Z"
                  transform="translate(12.875 12.878)"
               />
               <path
                  id="Path_226"
                  data-name="Path 226"
                  d="M20.236,41.341H5.325A5.33,5.33,0,0,1,0,36.016V8.325A5.33,5.33,0,0,1,5.325,3h4.26a1.065,1.065,0,1,1,0,2.13H5.325a3.2,3.2,0,0,0-3.2,3.2V36.016a3.2,3.2,0,0,0,3.2,3.2H20.236a1.065,1.065,0,0,1,0,2.13Z"
                  transform="translate(0 3.39)"
               />
               <path
                  id="Path_227"
                  data-name="Path 227"
                  d="M21.585,22.171a1.065,1.065,0,0,1-1.065-1.065V8.325a3.2,3.2,0,0,0-3.2-3.2h-4.26a1.065,1.065,0,0,1,0-2.13h4.26A5.33,5.33,0,0,1,22.65,8.325v12.78A1.065,1.065,0,0,1,21.585,22.171Z"
                  transform="translate(13.561 3.39)"
               />
               <path
                  id="Path_228"
                  data-name="Path 228"
                  d="M19.976,12.78H7.2A3.2,3.2,0,0,1,4,9.585V5.325A1.065,1.065,0,0,1,5.065,4.26h3.3a5.327,5.327,0,0,1,10.437,0h3.3a1.065,1.065,0,0,1,1.065,1.065v4.26A3.2,3.2,0,0,1,19.976,12.78ZM6.13,6.39v3.2A1.068,1.068,0,0,0,7.2,10.65h12.78a1.068,1.068,0,0,0,1.065-1.065V6.39h-3.2A1.065,1.065,0,0,1,16.78,5.325a3.2,3.2,0,0,0-6.39,0A1.065,1.065,0,0,1,9.325,6.39Z"
                  transform="translate(4.52)"
               />
               <path
                  id="Path_229"
                  data-name="Path 229"
                  d="M25.366,10.13H4.065a1.065,1.065,0,0,1,0-2.13h21.3a1.065,1.065,0,1,1,0,2.13Z"
                  transform="translate(3.39 9.041)"
               />
               <path
                  id="Path_230"
                  data-name="Path 230"
                  d="M25.366,13.13H4.065a1.065,1.065,0,0,1,0-2.13h21.3a1.065,1.065,0,1,1,0,2.13Z"
                  transform="translate(3.39 12.431)"
               />
               <path
                  id="Path_231"
                  data-name="Path 231"
                  d="M25.366,16.13H4.065a1.065,1.065,0,1,1,0-2.13h21.3a1.065,1.065,0,1,1,0,2.13Z"
                  transform="translate(3.39 15.821)"
               />
            </svg>
            <span>Administration</span>
         </a>
         <a routerLink="students" routerLinkActive="active" title="Students">
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="50.078"
               height="32.66"
               viewBox="0 0 50.078 32.66"
            >
               <g id="user" transform="translate(0 -85.333)">
                  <g
                     id="Group_446"
                     data-name="Group 446"
                     transform="translate(17.418 85.333)"
                  >
                     <g
                        id="Group_445"
                        data-name="Group 445"
                        transform="translate(0 0)"
                     >
                        <path
                           id="Path_218"
                           data-name="Path 218"
                           d="M178.287,85.333a7.621,7.621,0,1,0,7.621,7.621A7.629,7.629,0,0,0,178.287,85.333Zm0,13.064a5.443,5.443,0,1,1,5.443-5.443A5.451,5.451,0,0,1,178.287,98.4Z"
                           transform="translate(-170.666 -85.333)"
                           fill="#434343"
                        />
                     </g>
                  </g>
                  <g
                     id="Group_448"
                     data-name="Group 448"
                     transform="translate(34.837 94.042)"
                  >
                     <g id="Group_447" data-name="Group 447">
                        <path
                           id="Path_219"
                           data-name="Path 219"
                           d="M346.777,170.667a5.443,5.443,0,1,0,5.443,5.443A5.451,5.451,0,0,0,346.777,170.667Zm0,8.709a3.266,3.266,0,1,1,3.266-3.266A3.27,3.27,0,0,1,346.777,179.376Z"
                           transform="translate(-341.334 -170.667)"
                           fill="#434343"
                        />
                     </g>
                  </g>
                  <g
                     id="Group_450"
                     data-name="Group 450"
                     transform="translate(4.509 94.042)"
                  >
                     <g id="Group_449" data-name="Group 449">
                        <path
                           id="Path_220"
                           data-name="Path 220"
                           d="M49.625,170.667a5.443,5.443,0,1,0,5.443,5.443A5.449,5.449,0,0,0,49.625,170.667Zm0,8.709a3.266,3.266,0,1,1,3.266-3.266A3.27,3.27,0,0,1,49.625,179.376Z"
                           transform="translate(-44.182 -170.667)"
                           fill="#434343"
                        />
                     </g>
                  </g>
                  <g
                     id="Group_452"
                     data-name="Group 452"
                     transform="translate(10.886 102.751)"
                  >
                     <g id="Group_451" data-name="Group 451">
                        <path
                           id="Path_221"
                           data-name="Path 221"
                           d="M120.818,256a14.169,14.169,0,0,0-14.153,14.152,1.089,1.089,0,1,0,2.177,0,11.975,11.975,0,0,1,23.95,0,1.089,1.089,0,1,0,2.177,0A14.169,14.169,0,0,0,120.818,256Z"
                           transform="translate(-106.666 -256)"
                           fill="#434343"
                        />
                     </g>
                  </g>
                  <g
                     id="Group_454"
                     data-name="Group 454"
                     transform="translate(34.682 107.106)"
                  >
                     <g
                        id="Group_453"
                        data-name="Group 453"
                        transform="translate(0 0)"
                     >
                        <path
                           id="Path_222"
                           data-name="Path 222"
                           d="M345.411,298.667a9.8,9.8,0,0,0-5.075,1.415,1.089,1.089,0,1,0,1.13,1.862,7.622,7.622,0,0,1,11.566,6.521,1.089,1.089,0,0,0,2.177,0A9.81,9.81,0,0,0,345.411,298.667Z"
                           transform="translate(-339.813 -298.667)"
                           fill="#434343"
                        />
                     </g>
                  </g>
                  <g
                     id="Group_456"
                     data-name="Group 456"
                     transform="translate(0 107.106)"
                  >
                     <g
                        id="Group_455"
                        data-name="Group 455"
                        transform="translate(0 0)"
                     >
                        <path
                           id="Path_223"
                           data-name="Path 223"
                           d="M14.871,300.08A9.8,9.8,0,0,0,0,308.465a1.089,1.089,0,0,0,2.177,0,7.623,7.623,0,0,1,11.564-6.523,1.089,1.089,0,1,0,1.13-1.862Z"
                           transform="translate(0 -298.667)"
                           fill="#434343"
                        />
                     </g>
                  </g>
               </g>
            </svg>
            <span>Students</span>
         </a>
         <a routerLink="requests" routerLinkActive="active" title="Requests">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="40"
            height="40" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
               <style type="text/css">
                  .st0{fill: rgb(67, 67, 67);}
               </style>
               <g>
                  <path class="st0" d="M24.87,49.35c-7.24,0-14.49,0-21.73,0c-1.6,0-2.47-0.87-2.47-2.46c0-8.69,0.01-17.38-0.01-26.07   c0-1.35,0.51-2.43,1.56-3.26c0.86-0.68,1.71-1.36,2.58-2.02c0.25-0.19,0.35-0.39,0.35-0.71C5.14,12.12,5.15,9.41,5.15,6.7   c0-1.28,0.58-1.86,1.86-1.86c3.66,0,7.32,0.01,10.99-0.01c0.27,0,0.59-0.12,0.81-0.28c1.31-1,2.64-1.98,3.89-3.06   c1.17-1.01,3.25-1.01,4.41,0c1.25,1.09,2.6,2.07,3.93,3.08c0.21,0.16,0.51,0.26,0.77,0.26c3.66,0.02,7.32,0.01,10.99,0.01   c1.38,0,1.92,0.54,1.92,1.93c0,2.7,0.01,5.39-0.01,8.09c0,0.3,0.09,0.49,0.33,0.67c0.87,0.66,1.73,1.34,2.59,2.02   c1.06,0.84,1.58,1.91,1.58,3.29c-0.02,8.66-0.03,17.32,0.01,25.98c0.01,1.6-1.04,2.56-2.55,2.55   C39.4,49.33,32.14,49.35,24.87,49.35z M43.28,6.29c-0.22-0.01-0.38-0.02-0.53-0.02c-11.87,0-23.75,0-35.62-0.01   c-0.43,0-0.56,0.1-0.56,0.55c0.02,4.96,0.01,9.93,0,14.89c0,0.32,0.09,0.52,0.35,0.72c3.41,2.66,6.82,5.33,10.22,8   c0.15,0.12,0.3,0.23,0.43,0.38c0.24,0.27,0.26,0.59,0.04,0.87c-0.23,0.3-0.54,0.38-0.89,0.2c-0.14-0.07-0.26-0.17-0.39-0.27   c-4.62-3.62-9.23-7.24-13.85-10.85c-0.11-0.08-0.22-0.15-0.35-0.24c0,8.83,0,17.61,0,26.45c0.25-0.2,0.44-0.36,0.64-0.52   c6.24-5.19,12.48-10.37,18.73-15.56c0.85-0.7,1.78-1.19,2.9-1.3c1.59-0.16,2.9,0.41,4.09,1.42c6.28,5.27,12.57,10.53,18.85,15.78   c0.12,0.1,0.24,0.18,0.39,0.3c0-8.88,0-17.7,0-26.58c-0.17,0.13-0.3,0.21-0.42,0.31c-4.31,3.37-8.62,6.74-12.92,10.1   c-0.4,0.31-0.79,0.64-1.21,0.93c-0.33,0.23-0.68,0.17-0.94-0.13c-0.27-0.31-0.22-0.65,0.05-0.94c0.1-0.1,0.21-0.19,0.33-0.28   c3.43-2.69,6.86-5.37,10.31-8.05c0.26-0.21,0.37-0.41,0.37-0.75c-0.01-4.95-0.01-9.9-0.01-14.84C43.28,6.66,43.28,6.51,43.28,6.29z    M3.24,47.89c14.44,0,28.79,0,43.19,0c-0.13-0.12-0.21-0.2-0.3-0.27C39.9,42.4,33.66,37.18,27.42,31.96   c-0.28-0.23-0.58-0.46-0.9-0.61c-1.53-0.74-2.9-0.41-4.18,0.65c-4.84,4.04-9.7,8.07-14.55,12.1C6.3,45.34,4.8,46.59,3.24,47.89z    M28.86,4.82c0.02-0.03,0.03-0.06,0.05-0.1c-1.04-0.8-2.06-1.63-3.12-2.39c-0.57-0.41-1.26-0.39-1.83,0.03   c-1.03,0.76-2.02,1.58-3.03,2.37c-0.01,0.01,0.01,0.05,0.01,0.09C23.58,4.82,26.22,4.82,28.86,4.82z M44.74,17.11   c0,1.33,0,2.56,0,3.87c0.84-0.66,1.63-1.28,2.47-1.93C46.36,18.38,45.58,17.77,44.74,17.11z M5.12,17.09   c-0.86,0.69-1.65,1.31-2.47,1.96c0.85,0.67,1.63,1.28,2.47,1.93C5.12,19.67,5.12,18.43,5.12,17.09z"/>
                  <path class="st0" d="M24.87,28.3c-5.35-0.11-9.62-4.47-9.49-9.68c0.14-5.37,4.44-9.56,9.7-9.44c5.27,0.12,9.48,4.46,9.4,9.61   C34.4,24.1,30.16,28.28,24.87,28.3z M33.05,18.74c0.02-4.46-3.6-8.1-8.08-8.13c-4.48-0.04-8.13,3.57-8.17,8.09   c-0.04,4.46,3.61,8.14,8.1,8.17C29.36,26.9,33.03,23.23,33.05,18.74z"/>
                  <path class="st0" d="M23.97,19.85c-0.01-0.95,0.33-1.73,1.1-2.31c0.21-0.16,0.41-0.35,0.59-0.55c0.59-0.62,0.65-1.44,0.17-1.92   c-0.5-0.5-1.66-0.51-2.19-0.02c-0.12,0.11-0.22,0.23-0.32,0.35c-0.22,0.25-0.48,0.31-0.77,0.16c-0.31-0.16-0.45-0.44-0.33-0.75   c0.11-0.3,0.3-0.61,0.53-0.82c1.04-0.94,3.21-0.86,4.21,0.12c0.9,0.88,0.89,2.31-0.05,3.39c-0.25,0.29-0.51,0.57-0.8,0.81   c-0.56,0.47-0.85,1.03-0.82,1.78c0.02,0.56-0.54,0.92-1,0.61c-0.22-0.15-0.3-0.52-0.44-0.79C23.89,19.89,23.93,19.87,23.97,19.85z"/>
                  <path class="st0" d="M25.54,22.75c0,0.5-0.43,0.93-0.94,0.93c-0.51,0-0.92-0.42-0.92-0.94c0-0.52,0.42-0.94,0.93-0.93   C25.11,21.81,25.54,22.25,25.54,22.75z"/>
               </g>
               </svg>
            <span>Requests</span>
         </a>
         <!-- <a>
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="42.156"
               height="46.846"
               viewBox="0 0 42.156 46.846"
            >
               <g
                  id="calendar_1_"
                  data-name="calendar (1)"
                  transform="translate(-25.627)"
               >
                  <path
                     id="Path_246"
                     data-name="Path 246"
                     d="M59.058,23.007h3.268a1.341,1.341,0,0,0,1.34-1.34V18.4a1.341,1.341,0,0,0-1.34-1.34H59.058a1.341,1.341,0,0,0-1.34,1.34v3.268A1.341,1.341,0,0,0,59.058,23.007Zm.033-4.575h3.2v3.2h-3.2ZM59.058,31.7h3.268a1.341,1.341,0,0,0,1.34-1.34V27.091a1.341,1.341,0,0,0-1.34-1.34H59.058a1.341,1.341,0,0,0-1.34,1.34v3.268A1.341,1.341,0,0,0,59.058,31.7Zm.033-4.575h3.2v3.2h-3.2Zm-9.357-4.117H53a1.341,1.341,0,0,0,1.34-1.34V18.4A1.341,1.341,0,0,0,53,17.06H49.734a1.341,1.341,0,0,0-1.34,1.34v3.268A1.341,1.341,0,0,0,49.734,23.007Zm.033-4.575h3.2v3.2h-3.2Zm-15.415,15.6H31.084a1.341,1.341,0,0,0-1.34,1.34v3.268a1.341,1.341,0,0,0,1.34,1.34h3.268a1.341,1.341,0,0,0,1.34-1.34V35.376A1.341,1.341,0,0,0,34.352,34.036Zm-.033,4.575h-3.2v-3.2h3.2Zm.033-21.551H31.084a1.341,1.341,0,0,0-1.34,1.34v3.268a1.341,1.341,0,0,0,1.34,1.34h3.268a1.341,1.341,0,0,0,1.34-1.34V18.4A1.341,1.341,0,0,0,34.352,17.06Zm-.033,4.575h-3.2v-3.2h3.2ZM49.734,31.5H53a1.341,1.341,0,0,0,1.34-1.34V26.888A1.341,1.341,0,0,0,53,25.548H49.734a1.341,1.341,0,0,0-1.34,1.34v3.268A1.341,1.341,0,0,0,49.734,31.5Zm.033-4.575h3.2v3.2h-3.2ZM64.347,3.136H61.413V2.087A2.089,2.089,0,0,0,59.327,0h-.315a2.089,2.089,0,0,0-2.087,2.087V3.136H36.485V2.087A2.089,2.089,0,0,0,34.4,0h-.315A2.089,2.089,0,0,0,32,2.087V3.136H29.063a3.44,3.44,0,0,0-3.436,3.436V43.414a3.435,3.435,0,0,0,3.431,3.431H64.352a3.435,3.435,0,0,0,3.431-3.431V6.572a3.44,3.44,0,0,0-3.436-3.436ZM58.3,2.087a.715.715,0,0,1,.714-.714h.315a.715.715,0,0,1,.714.714V3.136H58.3Zm-24.928,0a.715.715,0,0,1,.714-.714H34.4a.715.715,0,0,1,.714.714V3.136H33.369V2.087ZM66.411,43.414a2.061,2.061,0,0,1-2.059,2.059H29.058A2.061,2.061,0,0,1,27,43.414v0a3.418,3.418,0,0,0,2.063.691H56.885a3.413,3.413,0,0,0,2.429-1.006l7.1-7.1Zm-7.8-1.561a2.935,2.935,0,0,0,.083-.692V36.581a1.568,1.568,0,0,1,1.567-1.566h4.581a2.935,2.935,0,0,0,.692-.083Zm7.8-28.911H37.171a.686.686,0,0,0,0,1.372H66.411V32.076a1.568,1.568,0,0,1-1.567,1.567H60.264a2.942,2.942,0,0,0-2.939,2.939v4.581a1.568,1.568,0,0,1-1.566,1.567h-26.7A2.066,2.066,0,0,1,27,40.665V14.315h7.427a.686.686,0,1,0,0-1.372H27V6.572a2.066,2.066,0,0,1,2.063-2.063H32V6.526a2.089,2.089,0,0,0,2.087,2.087.686.686,0,0,0,0-1.372.715.715,0,0,1-.714-.714V4.508H56.925V6.526a2.089,2.089,0,0,0,2.087,2.087.686.686,0,0,0,0-1.372.715.715,0,0,1-.714-.714V4.508h6.05a2.066,2.066,0,0,1,2.063,2.063ZM34.352,25.548H31.084a1.341,1.341,0,0,0-1.34,1.34v3.268a1.341,1.341,0,0,0,1.34,1.34h3.268a1.341,1.341,0,0,0,1.34-1.34V26.888A1.341,1.341,0,0,0,34.352,25.548Zm-.033,4.575h-3.2v-3.2h3.2Zm6.09-7.116h3.268a1.341,1.341,0,0,0,1.34-1.34V18.4a1.341,1.341,0,0,0-1.34-1.34H40.409a1.341,1.341,0,0,0-1.34,1.34v3.268A1.341,1.341,0,0,0,40.409,23.007Zm.033-4.575h3.2v3.2h-3.2Zm9.324,20.179a.686.686,0,0,0-1.372.033,1.341,1.341,0,0,0,1.34,1.34H53a1.341,1.341,0,0,0,1.34-1.34V35.376A1.341,1.341,0,0,0,53,34.036H49.734a1.341,1.341,0,0,0-1.34,1.34v.942a.686.686,0,0,0,1.372,0v-.91h3.2v3.2ZM40.409,31.5h3.268a1.341,1.341,0,0,0,1.34-1.34V26.888a1.341,1.341,0,0,0-1.34-1.34H40.409a1.341,1.341,0,0,0-1.34,1.34v3.268A1.341,1.341,0,0,0,40.409,31.5Zm.033-4.575h3.2v3.2h-3.2Zm-.033,13.063h3.268a1.341,1.341,0,0,0,1.34-1.34V35.376a1.341,1.341,0,0,0-1.34-1.34H40.409a1.341,1.341,0,0,0-1.34,1.34v3.268A1.341,1.341,0,0,0,40.409,39.983Zm.033-4.575h3.2v3.2h-3.2Z"
                  />
               </g>
            </svg>
            <span>Students</span>
         </a> -->
         <a routerLink="profile" routerLinkActive="active" title="Account"
            ><svg
               id="profile-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="38.334"
               height="42.826"
               viewBox="0 0 38.334 42.826"
            >
               <g id="user" transform="translate(-24.165)">
                  <g
                     id="Group_20"
                     data-name="Group 20"
                     transform="translate(32.216)"
                  >
                     <g id="Group_19" data-name="Group 19">
                        <path
                           id="Path_14"
                           data-name="Path 14"
                           d="M121.91,0a11.119,11.119,0,1,0,11.119,11.119A11.149,11.149,0,0,0,121.91,0Z"
                           transform="translate(-110.791)"
                           fill="#434343"
                        />
                     </g>
                  </g>
                  <g
                     id="Group_22"
                     data-name="Group 22"
                     transform="translate(24.165 23.034)"
                  >
                     <g
                        id="Group_21"
                        data-name="Group 21"
                        transform="translate(0)"
                     >
                        <path
                           id="Path_15"
                           data-name="Path 15"
                           d="M62.417,255.931a10.366,10.366,0,0,0-1.117-2.039,13.821,13.821,0,0,0-9.565-6.021,2.047,2.047,0,0,0-1.408.34,11.852,11.852,0,0,1-13.984,0,1.822,1.822,0,0,0-1.408-.34,13.721,13.721,0,0,0-9.565,6.021,11.952,11.952,0,0,0-1.117,2.039,1.033,1.033,0,0,0,.049.923,19.372,19.372,0,0,0,1.311,1.942,18.457,18.457,0,0,0,2.234,2.525,29.108,29.108,0,0,0,2.234,1.942,22.142,22.142,0,0,0,26.414,0,21.351,21.351,0,0,0,2.234-1.942,22.424,22.424,0,0,0,2.234-2.525,17.026,17.026,0,0,0,1.311-1.942A.829.829,0,0,0,62.417,255.931Z"
                           transform="translate(-24.165 -247.841)"
                           fill="#434343"
                        />
                     </g>
                  </g>
               </g></svg
            ><span>Account</span>
         </a>
         <a routerLink="help-center" routerLinkActive="active" title="Help Center"
            ><svg
               id="help-center-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="41.771"
               height="34.602"
               viewBox="0 0 41.771 34.602"
            >
               <g id="helPCenter" transform="translate(-169 -202.512)">
                  <path
                     id="Path_27"
                     data-name="Path 27"
                     d="M257.382,255.7a13.127,13.127,0,1,1-3.726,25.713.99.99,0,0,0-1.011.188,13.11,13.11,0,0,1-6.816,2.462c-.84.082-1.7.073-2.544.082-.359,0-.807-.082-.791-.522a1.043,1.043,0,0,1,.571-.685,8.341,8.341,0,0,0,3.669-4.19,2.168,2.168,0,0,0-.228-2.6,11.568,11.568,0,0,1-2.112-5.756,12.243,12.243,0,0,1,.294-4.68A13.04,13.04,0,0,1,257.382,255.7Zm-5.96,13.167a1.22,1.22,0,0,0,1.207,1.141,1.2,1.2,0,0,0,1.15-1.125,1.122,1.122,0,0,0-1.052-1.19A1.234,1.234,0,0,0,251.422,268.866Zm7.125-.049a1.089,1.089,0,0,0-1.166-1.125,1.135,1.135,0,0,0-1.15,1.158,1.214,1.214,0,0,0,1.117,1.158A1.178,1.178,0,0,0,258.548,268.817Zm3.538,1.174a1.182,1.182,0,0,0,1.223-1.1,1.152,1.152,0,0,0-1.06-1.2,1.272,1.272,0,0,0-1.3.97A1.255,1.255,0,0,0,262.086,269.991Z"
                     transform="translate(-67.503 -48.851)"
                     fill="#434343"
                  />
                  <path
                     id="Path_28"
                     data-name="Path 28"
                     d="M175.326,225.388a28.976,28.976,0,0,1-4.044-.041,2.836,2.836,0,0,1-2.258-2.837q-.049-3.608,0-7.231a3.061,3.061,0,0,1,2.813-2.935,11.213,11.213,0,0,1,1.655-.016.921.921,0,0,0,1-.587,17.079,17.079,0,0,1,11.381-8.748,17.355,17.355,0,0,1,19.371,8.723.951.951,0,0,0,1.052.611,11.265,11.265,0,0,1,1.484,0,3.085,3.085,0,0,1,2.968,3.033c.024,2.372.033,4.737,0,7.109a3.092,3.092,0,0,1-3.041,3.025c-.652.016-1.3-.024-1.957.024a.77.77,0,0,0-.546.367,16.414,16.414,0,0,1-11.65,10.036.86.86,0,0,0-.489.408,1.3,1.3,0,0,1-1.223.783c-1.011,0-2.014.008-3.025,0a1.244,1.244,0,1,1-.033-2.487c1.027-.016,2.054-.008,3.082,0a.891.891,0,0,1,.563.13c.448.481.938.277,1.419.13,6.3-1.924,10.232-6.066,11.316-12.6a15.484,15.484,0,1,0-30.018,2.487C175.212,224.988,175.261,225.176,175.326,225.388Z"
                     fill="#434343"
                  />
               </g></svg
            ><span>Help Center</span></a
         >
      </nav>
      <!-- <nav
         *ngIf="this.userRole == '1' "
         class="nav-bar"
         [ngClass]="{ expand: this.expandedIndex === i }"
         #navbar
      >
         <a routerLink="dashboard" routerLinkActive="active"
            ><svg
               id="dashboard"
               xmlns="http://www.w3.org/2000/svg"
               width="38"
               height="38"
               viewBox="0 0 38 38"
            >
               <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M14.643,12.669H2.768A2.775,2.775,0,0,1,0,9.893V2.768A2.768,2.768,0,0,1,2.768,0H14.643a2.768,2.768,0,0,1,2.768,2.768V9.893A2.77,2.77,0,0,1,14.643,12.669ZM2.768,2.375a.4.4,0,0,0-.393.393V9.893a.4.4,0,0,0,.393.393H14.643a.4.4,0,0,0,.393-.393V2.768a.4.4,0,0,0-.393-.393H2.768Z"
                  fill="#434343"
               />
               <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M14.643,235.562H2.768A2.768,2.768,0,0,1,0,232.793V216.168A2.768,2.768,0,0,1,2.768,213.4H14.643a2.768,2.768,0,0,1,2.768,2.768v16.625A2.764,2.764,0,0,1,14.643,235.562ZM2.768,215.768a.4.4,0,0,0-.393.393v16.625a.4.4,0,0,0,.393.393H14.643a.4.4,0,0,0,.393-.393V216.161a.4.4,0,0,0-.393-.393Z"
                  transform="translate(0 -197.562)"
                  fill="#434343"
               />
               <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M292.043,354.062H280.168a2.768,2.768,0,0,1-2.768-2.768v-7.125a2.768,2.768,0,0,1,2.768-2.768h11.875a2.768,2.768,0,0,1,2.768,2.768v7.125A2.768,2.768,0,0,1,292.043,354.062Zm-11.875-10.294a.4.4,0,0,0-.393.393v7.125a.4.4,0,0,0,.393.393h11.875a.4.4,0,0,0,.393-.393v-7.125a.4.4,0,0,0-.393-.393Z"
                  transform="translate(-256.812 -316.062)"
                  fill="#434343"
               />
               <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M292.043,22.261H280.168a2.768,2.768,0,0,1-2.768-2.768V2.868A2.768,2.768,0,0,1,280.168.1h11.875a2.757,2.757,0,0,1,2.768,2.761V19.486A2.775,2.775,0,0,1,292.043,22.261ZM280.168,2.467a.4.4,0,0,0-.393.393V19.486a.4.4,0,0,0,.393.393h11.875a.4.4,0,0,0,.393-.393V2.861a.4.4,0,0,0-.393-.393H280.168Z"
                  transform="translate(-256.812 -0.092)"
                  fill="#434343"
               /></svg
            ><span>Dashboard</span>
         </a>
         <a routerLink="administration" routerLinkActive="active">
            <svg
               id="Administrimi"
               xmlns="http://www.w3.org/2000/svg"
               width="44.919"
               height="36.437"
               viewBox="0 0 44.919 36.437"
            >
               <path
                  id="Path_68"
                  data-name="Path 68"
                  d="M569.5,198.8H552.8v13.449l4.584,4.77-4.584,4.843v13.375h16.726a3.826,3.826,0,0,0,3.83-3.83v-28.75A3.856,3.856,0,0,0,569.5,198.8Zm-12.739,12.165a2.026,2.026,0,0,1-2.027-2.027h0a2.026,2.026,0,0,1,2.027-2.027h7.209A2.026,2.026,0,0,1,566,208.937h0a2.026,2.026,0,0,1-2.027,2.027ZM566,225.1a2.026,2.026,0,0,1-2.027,2.027h-7.209a2.026,2.026,0,0,1-2.027-2.027h0a2.026,2.026,0,0,1,2.027-2.027h7.209A2.026,2.026,0,0,1,566,225.1Zm1.915-8.082a2.026,2.026,0,0,1-2.028,2.027h-5.339a2.026,2.026,0,0,1-2.027-2.027h0a2.026,2.026,0,0,1,2.027-2.027h5.339a2.026,2.026,0,0,1,2.028,2.027Z"
                  transform="translate(-528.437 -198.8)"
                  fill="#434343"
               />
               <path
                  id="Path_69"
                  data-name="Path 69"
                  d="M140.756,213.752V198.8h-16.7a3.86,3.86,0,0,0-3.858,3.858v28.75a3.826,3.826,0,0,0,3.83,3.83h16.726V220.189l3.1-3.171Zm-16.816-4.815a2.026,2.026,0,0,1,2.027-2.027h7.209a2.026,2.026,0,0,1,2.027,2.027h0a2.026,2.026,0,0,1-2.027,2.027h-7.209a2.026,2.026,0,0,1-2.027-2.027ZM135.2,225.1a2.026,2.026,0,0,1-2.027,2.027h-7.209a2.026,2.026,0,0,1-2.027-2.027h0a2.026,2.026,0,0,1,2.027-2.027h7.209A2.026,2.026,0,0,1,135.2,225.1Zm1.915-8.082a2.026,2.026,0,0,1-2.027,2.027h-7.04a2.026,2.026,0,0,1-2.027-2.027h0a2.026,2.026,0,0,1,2.027-2.027h7.04a2.026,2.026,0,0,1,2.027,2.027Z"
                  transform="translate(-120.2 -198.8)"
                  fill="#434343"
               />
            </svg>
            <span>Administration</span>
         </a>
         <a routerLink="add-credits" routerLinkActive="active">
            <svg
               id="add-credit-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="48.704"
               height="43.408"
               viewBox="0 0 48.704 43.408"
            >
               <g
                  id="Group_18"
                  data-name="Group 18"
                  transform="translate(-1585.591 -283.432)"
               >
                  <path
                     id="coins"
                     d="M115.384,9.805c-.069-1.181-1.459-2.084-4.307-2.848a2.029,2.029,0,0,0,.139-.625V1.468h0C110.938-2.561,94.4-2.7,92.458-2.7c-1.876,0-18.48.139-18.758,4.168h0v.069h0V6.331c0,1.32,1.737,2.362,4.238,3.126,0,.139-.069.208-.069.347h0v.069h0v4.794c-2.709.695-4.1,1.6-4.168,2.779h0v.069h0V22.31c0,.9.834,1.667,2.154,2.362a.881.881,0,0,0-.069.417h0v.069h0v4.794c0,2.293,5.21,3.752,10.977,4.446h.208c1.112.139,2.223.208,3.335.278h.139c1.389.069,2.848.139,4.1.139s2.709-.069,4.1-.139h.139c1.112-.069,2.223-.139,3.335-.278h.208c5.766-.695,10.977-2.084,10.977-4.446V25.089h0c-.069-.834-.764-1.528-2.223-2.154a2.029,2.029,0,0,0,.139-.625V17.795c2.5-.764,4.168-1.806,4.168-3.126V9.805Zm-1.389.069c-.069.486-1.112,1.112-3.057,1.667h0a46,46,0,0,1-11.185,1.667H93.5a46,46,0,0,1-11.185-1.667h0c-1.876-.556-2.987-1.181-3.057-1.667V9.805H79.4l.834.208a41.161,41.161,0,0,0,4.516.695h0c1.112.139,2.293.208,3.474.278h0c.834.069,1.737.069,2.57.139H93.5a54.186,54.186,0,0,0,12.991-1.6c.139-.069.278-.069.417-.139.069,0,.208-.069.278-.069a2.08,2.08,0,0,0,.695-.278c.069,0,.069,0,.139-.069a4.787,4.787,0,0,0,.556-.208.243.243,0,0,0,.139-.069c.208-.069.347-.208.556-.278.069-.069.139-.069.208-.139s.139-.069.278-.139c.069,0,.069-.069.139-.069C113.091,8.833,113.925,9.6,113.994,9.875ZM92.527-1.311C103.99-1.311,109.756.5,109.9,1.538c-.069.486-1.181,1.112-3.057,1.667h0A46,46,0,0,1,95.653,4.873H89.4A46,46,0,0,1,78.216,3.205h0c-1.876-.556-2.987-1.181-3.057-1.667C75.228.5,81.064-1.311,92.527-1.311Zm-14.034,17.3h0c.973.973,2.987,1.737,5.419,2.293.069,0,.139,0,.139.069.208.069.347.069.556.139a48.389,48.389,0,0,0,7.85.973h0c.973.069,1.876.069,2.918.139h2.709c.9,0,1.806-.069,2.709-.139h0a50.81,50.81,0,0,0,7.989-1.042,10.7,10.7,0,0,1-2.084.834h0a45.3,45.3,0,0,1-12.019,1.667H89.262a46,46,0,0,1-11.185-1.667h0C76.132,18.7,75.089,18,75.02,17.586,75.228,17.239,75.923,16.613,78.494,15.988Zm33.416,9.17c-.069.486-1.112,1.112-3.057,1.667h0a46,46,0,0,1-11.185,1.667H91.416A46,46,0,0,1,80.23,26.826h0c-1.806-.556-2.918-1.181-3.057-1.667l.625.208h.069a1.635,1.635,0,0,0,.556.139c.069,0,.139.069.208.069.139,0,.208.069.347.069a52.606,52.606,0,0,0,9.24,1.32h0c1.112.069,2.154.069,3.265.139h2.084c1.042,0,2.015-.069,2.987-.139h0c1.181-.069,2.362-.208,3.474-.278h.069c1.251-.139,2.432-.347,3.474-.556.208-.069.417-.069.695-.139h.139a18.04,18.04,0,0,0,5.072-1.667c.069-.069.139-.069.208-.139s.139-.069.208-.139.139-.069.208-.139C111.493,24.533,111.91,25.02,111.91,25.159Z"
                     transform="translate(1511.891 286.132)"
                     fill="#434343"
                  />
                  <g
                     id="Ellipse_3"
                     data-name="Ellipse 3"
                     transform="translate(1612.295 305.84)"
                     fill="#434343"
                     stroke="#fff"
                     stroke-width="3"
                  >
                     <ellipse
                        cx="11"
                        cy="10.5"
                        rx="11"
                        ry="10.5"
                        stroke="none"
                     />
                     <ellipse cx="11" cy="10.5" rx="9.5" ry="9" fill="none" />
                  </g>
                  <text
                     id="_"
                     data-name="+"
                     transform="translate(1619.295 320.84)"
                     fill="#fff"
                     font-size="14"
                     font-family="Montserrat-Black, Montserrat"
                     font-weight="800"
                  >
                     <tspan x="0" y="0">+</tspan>
                  </text>
               </g></svg
            ><span>Add Credit</span>
         </a>
         <a routerLink="statistics" routerLinkActive="active"
            ><svg
               id="statistics-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="40.214"
               height="36.2"
               viewBox="0 0 40.214 36.2"
            >
               <g id="graph" transform="translate(0 -25.55)">
                  <g
                     id="Group_2"
                     data-name="Group 2"
                     transform="translate(0 25.55)"
                  >
                     <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M36.2,25.55a4.011,4.011,0,0,0-2.891,6.8l-7.345,14.7A3.3,3.3,0,0,0,25.476,47a4.012,4.012,0,0,0-1.516.3l-5.7-6.418a4.013,4.013,0,1,0-7.526-1.933,3.991,3.991,0,0,0,.99,2.608L4.737,53.776a3.676,3.676,0,0,0-.715-.071,4.078,4.078,0,1,0,3.032,1.414L14.031,42.9a3.782,3.782,0,0,0,2.223-.228l5.7,6.418a4.018,4.018,0,1,0,6.4-.848l7.345-14.7a3.3,3.3,0,0,0,.487.047A4.022,4.022,0,0,0,36.2,25.55Z"
                        transform="translate(0 -25.55)"
                        fill="#434343"
                     />
                  </g>
               </g></svg
            ><span>Dashboard</span>
         </a>
         <a routerLink="requests" routerLinkActive="active"
            ><svg
               id="kerkesa"
               xmlns="http://www.w3.org/2000/svg"
               width="46.618"
               height="46.618"
               viewBox="0 0 46.618 46.618"
            >
               <defs>
                  <style>
                     .a {
                        fill: #434343;
                     }
                  </style>
               </defs>
               <g transform="translate(-0.001 0)">
                  <path
                     class="a"
                     d="M13.106,253.913a7.217,7.217,0,1,0-8.851,0A8.671,8.671,0,0,0,0,261.384v2.926a1.366,1.366,0,0,0,1.366,1.366H16a1.366,1.366,0,0,0,1.366-1.366v-2.926a8.671,8.671,0,0,0-4.255-7.471Zm-8.911-5.695A4.486,4.486,0,1,1,8.681,252.7a4.491,4.491,0,0,1-4.486-4.486ZM14.63,262.944H2.732v-1.56a5.949,5.949,0,0,1,11.9,0v1.56Zm0,0"
                     transform="translate(0 -219.058)"
                  />
                  <path
                     class="a"
                     d="M216.11,0H198.555A5.751,5.751,0,0,0,192.8,5.754V32.086a1.367,1.367,0,0,0,2.185,1.093l5.487-4.115H216.11a5.751,5.751,0,0,0,5.754-5.754V5.754A5.751,5.751,0,0,0,216.11,0Zm3.023,23.309a3.02,3.02,0,0,1-3.023,3.023H200.018a1.367,1.367,0,0,0-.819.273l-3.666,2.75V5.754a3.02,3.02,0,0,1,3.023-3.023H216.11a3.02,3.02,0,0,1,3.023,3.023Zm0,0"
                     transform="translate(-175.246)"
                  />
                  <path
                     class="a"
                     d="M273.061,80.332H258.432a1.366,1.366,0,0,0,0,2.732h14.629a1.366,1.366,0,0,0,0-2.732Zm0,0"
                     transform="translate(-233.659 -73.018)"
                  />
                  <path
                     class="a"
                     d="M273.061,144.6H258.432a1.366,1.366,0,0,0,0,2.732h14.629a1.366,1.366,0,0,0,0-2.732Zm0,0"
                     transform="translate(-233.659 -131.436)"
                  />
                  <path
                     class="a"
                     d="M265.746,208.867h-7.314a1.366,1.366,0,0,0,0,2.732h7.314a1.366,1.366,0,0,0,0-2.732Zm0,0"
                     transform="translate(-233.659 -189.85)"
                  />
               </g></svg
            ><span>kerkesa</span></a
         >
         <a routerLink="profile" routerLinkActive="active"
            ><svg
               id="profile-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="38.334"
               height="42.826"
               viewBox="0 0 38.334 42.826"
            >
               <g id="user" transform="translate(-24.165)">
                  <g
                     id="Group_20"
                     data-name="Group 20"
                     transform="translate(32.216)"
                  >
                     <g id="Group_19" data-name="Group 19">
                        <path
                           id="Path_14"
                           data-name="Path 14"
                           d="M121.91,0a11.119,11.119,0,1,0,11.119,11.119A11.149,11.149,0,0,0,121.91,0Z"
                           transform="translate(-110.791)"
                           fill="#434343"
                        />
                     </g>
                  </g>
                  <g
                     id="Group_22"
                     data-name="Group 22"
                     transform="translate(24.165 23.034)"
                  >
                     <g
                        id="Group_21"
                        data-name="Group 21"
                        transform="translate(0)"
                     >
                        <path
                           id="Path_15"
                           data-name="Path 15"
                           d="M62.417,255.931a10.366,10.366,0,0,0-1.117-2.039,13.821,13.821,0,0,0-9.565-6.021,2.047,2.047,0,0,0-1.408.34,11.852,11.852,0,0,1-13.984,0,1.822,1.822,0,0,0-1.408-.34,13.721,13.721,0,0,0-9.565,6.021,11.952,11.952,0,0,0-1.117,2.039,1.033,1.033,0,0,0,.049.923,19.372,19.372,0,0,0,1.311,1.942,18.457,18.457,0,0,0,2.234,2.525,29.108,29.108,0,0,0,2.234,1.942,22.142,22.142,0,0,0,26.414,0,21.351,21.351,0,0,0,2.234-1.942,22.424,22.424,0,0,0,2.234-2.525,17.026,17.026,0,0,0,1.311-1.942A.829.829,0,0,0,62.417,255.931Z"
                           transform="translate(-24.165 -247.841)"
                           fill="#434343"
                        />
                     </g>
                  </g>
               </g></svg
            ><span>Account</span></a
         >
         <a routerLink="help-center" routerLinkActive="active"
            ><svg
               id="help-center-icon"
               xmlns="http://www.w3.org/2000/svg"
               width="41.771"
               height="34.602"
               viewBox="0 0 41.771 34.602"
            >
               <g id="helPCenter" transform="translate(-169 -202.512)">
                  <path
                     id="Path_27"
                     data-name="Path 27"
                     d="M257.382,255.7a13.127,13.127,0,1,1-3.726,25.713.99.99,0,0,0-1.011.188,13.11,13.11,0,0,1-6.816,2.462c-.84.082-1.7.073-2.544.082-.359,0-.807-.082-.791-.522a1.043,1.043,0,0,1,.571-.685,8.341,8.341,0,0,0,3.669-4.19,2.168,2.168,0,0,0-.228-2.6,11.568,11.568,0,0,1-2.112-5.756,12.243,12.243,0,0,1,.294-4.68A13.04,13.04,0,0,1,257.382,255.7Zm-5.96,13.167a1.22,1.22,0,0,0,1.207,1.141,1.2,1.2,0,0,0,1.15-1.125,1.122,1.122,0,0,0-1.052-1.19A1.234,1.234,0,0,0,251.422,268.866Zm7.125-.049a1.089,1.089,0,0,0-1.166-1.125,1.135,1.135,0,0,0-1.15,1.158,1.214,1.214,0,0,0,1.117,1.158A1.178,1.178,0,0,0,258.548,268.817Zm3.538,1.174a1.182,1.182,0,0,0,1.223-1.1,1.152,1.152,0,0,0-1.06-1.2,1.272,1.272,0,0,0-1.3.97A1.255,1.255,0,0,0,262.086,269.991Z"
                     transform="translate(-67.503 -48.851)"
                     fill="#434343"
                  />
                  <path
                     id="Path_28"
                     data-name="Path 28"
                     d="M175.326,225.388a28.976,28.976,0,0,1-4.044-.041,2.836,2.836,0,0,1-2.258-2.837q-.049-3.608,0-7.231a3.061,3.061,0,0,1,2.813-2.935,11.213,11.213,0,0,1,1.655-.016.921.921,0,0,0,1-.587,17.079,17.079,0,0,1,11.381-8.748,17.355,17.355,0,0,1,19.371,8.723.951.951,0,0,0,1.052.611,11.265,11.265,0,0,1,1.484,0,3.085,3.085,0,0,1,2.968,3.033c.024,2.372.033,4.737,0,7.109a3.092,3.092,0,0,1-3.041,3.025c-.652.016-1.3-.024-1.957.024a.77.77,0,0,0-.546.367,16.414,16.414,0,0,1-11.65,10.036.86.86,0,0,0-.489.408,1.3,1.3,0,0,1-1.223.783c-1.011,0-2.014.008-3.025,0a1.244,1.244,0,1,1-.033-2.487c1.027-.016,2.054-.008,3.082,0a.891.891,0,0,1,.563.13c.448.481.938.277,1.419.13,6.3-1.924,10.232-6.066,11.316-12.6a15.484,15.484,0,1,0-30.018,2.487C175.212,224.988,175.261,225.176,175.326,225.388Z"
                     fill="#434343"
                  />
               </g></svg
            ><span>Help Center</span></a
         >
      </nav> -->
      <router-outlet></router-outlet>
   </section>
</ng-container>
